import React from 'react';
import { Loader, BaasicCheckbox } from 'core/components';
import { defaultTemplate } from 'core/hoc';
import _ from 'lodash';

const SellerWarehouseTemplate = ({
	t,
	viewStore: {
		loading,
		sellerWarehouses,
		modalParams,
		handleOnChange,
		updateSellerWarehouses,
	},
}) => {
	if (loading) return <Loader />;
	return (
		<section>
			<div className="ReactModal__header">
				<h3 className="spc--bottom--sml">{t('SELLERWAREHOUSE.WAREHOUSES')}</h3>
			</div>
			<div className="ReactModal__body">
				<div className="card card--med spc--bottom--sml">{t('SELLERWAREHOUSE.NOTE')}</div>
				<div className="card card--med spc--bottom--sml">
					{_.map(sellerWarehouses, item => {
						return (
							<div>
								<BaasicCheckbox
									checked={item.isActive}
									onChangeCallback={() => handleOnChange(item)}
									id={item.id}
									className={'input--check'}
									label={item.warehouse.applicationTitle}
								/>
							</div>
						);
					})}
				</div>
			</div>
			<div className="ReactModal__footer">
				<button
					className="btn btn--med btn--primary spc--right--tny spc--bottom--sml"
					type="button"
					onClick={() => updateSellerWarehouses()}
				>
					{t('SELLERWAREHOUSE.APPLY')}
				</button>
				<button
					className="btn btn--med btn--outline spc--bottom--sml"
					onClick={modalParams.close}
				>
					{t('CANCEL')}
				</button>
			</div>
		</section>
	);
};

export default defaultTemplate(SellerWarehouseTemplate);
